import { find } from 'lodash';

import { savedListTypes } from '../utils';
import {
    getSavedPlayerAndLists,
    getSavedSchoolsAndLists,
    checkIfListExists,
    createList,
    createPlayerWithLists,
    createSchoolWithLists,
    updatePlayerLists,
    updateSchoolLists,
} from '../api/savedListsApi';

export const saveData = () => async (dispatch, getState) => {
    try {
        const { listType, savedItem, savedLists } = getState().manageLists;
        const selectedIds = [];
        savedLists.forEach((savedList) => {
            if (savedList.isSelected) {
                selectedIds.push(savedList.id);
            }
        });
        if (listType === savedListTypes.players.key) {
            if (savedItem) {
                dispatch(updateSavedPlayerWithLists(selectedIds));
            } else {
                dispatch(createSavedPlayerAndLists(selectedIds));
            }
        } else if (listType === savedListTypes.schools.key) {
            if (savedItem) {
                dispatch(updateSavedSchoolWithLists(selectedIds));
            } else {
                dispatch(createSavedSchoolAndLists(selectedIds));
            }
        }
    } catch (err) {
        throw err;
    }
};

export const createSavedPlayerAndLists = (selectedIds) => async (dispatch, getState, { mainApi }) => {
    const { id } = getState().manageLists;

    dispatch({ type: 'MANAGE_LISTS:SAVE' });
    createPlayerWithLists(mainApi, selectedIds, id)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
                throw new Error('FAILED');
            } else {
                dispatch({ type: 'MANAGE_LISTS:SAVE_SUCCESS' });
            }
        })
        .catch(() => {
            dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
            throw new Error('FAILED');
        });
};

export const createSavedSchoolAndLists = (selectedIds) => async (dispatch, getState, { mainApi }) => {
    const { id } = getState().manageLists;

    dispatch({ type: 'MANAGE_LISTS:SAVE' });
    createSchoolWithLists(mainApi, selectedIds, id)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
                throw new Error('FAILED');
            } else {
                dispatch({ type: 'MANAGE_LISTS:SAVE_SUCCESS' });
            }
        })
        .catch(() => {
            dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
            throw new Error('FAILED');
        });
};

export const updateSavedPlayerWithLists = (selectedIds) => async (dispatch, getState, { mainApi }) => {
    const { savedItem } = getState().manageLists;

    dispatch({ type: 'MANAGE_LISTS:SAVE' });
    updatePlayerLists(mainApi, selectedIds, savedItem.savedId)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
                throw new Error('FAILED');
            } else {
                dispatch({ type: 'MANAGE_LISTS:SAVE_SUCCESS' });
            }
        })
        .catch(() => {
            dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
            throw new Error('FAILED');
        });
};

export const updateSavedSchoolWithLists = (selectedIds) => async (dispatch, getState, { mainApi }) => {
    const { savedItem } = getState().manageLists;

    dispatch({ type: 'MANAGE_LISTS:SAVE' });
    updateSchoolLists(mainApi, selectedIds, savedItem.savedId)
        .then((result) => {
            const { data } = result;
            if (data.error) {
                dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
                throw new Error('FAILED');
            } else {
                dispatch({ type: 'MANAGE_LISTS:SAVE_SUCCESS' });
            }
        })
        .catch(() => {
            dispatch({ type: 'MANAGE_LISTS:SAVE_FAILED' });
            throw new Error('FAILED');
        });
};

export function addListTypeAndId(listType, id) {
    return (dispatch) => {
        dispatch({
            type: 'MANAGE_LISTS:ADD_TYPE_ID',
            data: {
                listType,
                id: parseInt(id),
            },
        });
        dispatch(fetchListsAndSavedData());
    };
}

export function fetchListsAndSavedData() {
    return (dispatch, getState) => {
        const { listType } = getState().manageLists;
        if (listType === savedListTypes.players.key) {
            dispatch(fetchSavedPlayerAndLists());
        } else if (listType === savedListTypes.schools.key) {
            dispatch(fetchSavedSchoolAndLists());
        }
    };
}

export function fetchSavedPlayerAndLists() {
    return (dispatch, getState, { mainApi }) => {
        const { id } = getState().manageLists;
        dispatch({ type: 'SPLASH_SHOW_LOADING', title: 'Loading' });
        dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST' });
        getSavedPlayerAndLists(mainApi, id)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST_FAILURE' });
                    dispatch({ type: 'SPLASH_HIDE' });
                } else {
                    dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST_SUCCESS' });
                    dispatch(processList(data));
                    dispatch({ type: 'SPLASH_HIDE' });
                }
            })
            .catch(() => {
                dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST_FAILURE' });
                dispatch({ type: 'SPLASH_HIDE' });
            });
    };
}

export function fetchSavedSchoolAndLists() {
    return (dispatch, getState, { mainApi }) => {
        const { id } = getState().manageLists;
        dispatch({ type: 'SPLASH_SHOW_LOADING', title: 'Loading' });
        dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST' });
        getSavedSchoolsAndLists(mainApi, id)
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST_FAILURE' });
                    dispatch({ type: 'SPLASH_HIDE' });
                } else {
                    dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST_SUCCESS' });
                    dispatch(processList(data));
                    dispatch({ type: 'SPLASH_HIDE' });
                }
            })
            .catch(() => {
                dispatch({ type: 'MANAGE_LISTS:FETCH_SAVED_LIST_FAILURE' });
                dispatch({ type: 'SPLASH_HIDE' });
            });
    };
}

export function processList(data) {
    return (dispatch, getState) => {
        const { listType, id } = getState().manageLists;
        let savedItem;
        const listArray = data.savedLists ? data.savedLists : [];
        if (listType === savedListTypes.players.key) {
            savedItem = data.savedPlayer;
        } else if (listType === savedListTypes.schools.key) {
            savedItem = data.savedSchool;
        }
        const lists = [];
        listArray.forEach((savedList) => {
            const newItem = {};
            newItem.id = savedList.id;
            newItem.name = savedList.name;
            if (listType === savedListTypes.players.key) {
                newItem.isSelected = !!find(savedList.players, (savedItem) => { return savedItem.item.id === id; });
            } else if (listType === savedListTypes.schools.key) {
                newItem.isSelected = !!find(savedList.schools, (savedItem) => { return savedItem.item.id === id; });
            }
            lists.push(newItem);
        });
        dispatch({ type: 'MANAGE_LISTS:SAVE_PROCESSED_DATA', data: { savedItem, savedLists: lists } });
        dispatch(sortSavedLists());
    };
}

export function onSelectionChanged(listItem) {
    return (dispatch, getState) => {
        const { savedLists } = getState().manageLists;
        find(savedLists, { id: listItem.id }).isSelected = !listItem.isSelected;
        dispatch({ type: 'MANAGE_LISTS:UPDATE_SAVED_LIST', data: { savedLists } });
    };
}

export const createSavedList = (listName) => async (dispatch, getState, { mainApi }) => {
    try {
        const { savedLists, listType } = getState().manageLists;
        dispatch({ type: 'MANAGE_LISTS:CREATE_LIST', data: { listname: listName } });
        const result = await checkIfListExists(mainApi, listName, listType);
        const { data } = result;
        if (data.isError) {
            dispatch({ type: 'MANAGE_LISTS:CREATE_LIST_FAILURE', data });
            throw new Error('exists');
        } else {
            createList(mainApi, listName, listType)
                .then((result) => {
                    const { data } = result;
                    if (data.isError) {
                        dispatch({ type: 'MANAGE_LISTS:CREATE_LIST_FAILURE', data });
                    } else {
                        const newItem = {};
                        newItem.id = data.id;
                        newItem.name = data.name;
                        newItem.isSelected = true;
                        savedLists.push(newItem);
                        dispatch({
                            type: 'MANAGE_LISTS:CREATE_LIST_SUCCESS',
                            data: { savedLists },
                        });
                        dispatch(sortSavedLists());
                    }
                })
                .catch(() => {
                    dispatch({
                        type: 'MANAGE_LISTS:CREATE_LIST_FAILURE',
                        data: { isError: true, errorMessage: 'List Creation Failed' },
                    });
                });
        }
    } catch (err) {
        throw err;
    }
};

export function sortSavedLists() {
    const comparator = (item1, item2) => {
        if (item1.name < item2.name) {
            return -1;
        } if (item1.name > item2.name) {
            return 1;
        }
        return 0;
    };

    return (dispatch, getState) => {
        const { savedLists } = getState().manageLists;
        dispatch({ type: 'MANAGE_LISTS:UPDATE_SAVED_LIST', data: { savedLists: savedLists.sort(comparator) } });
    };
}
